export interface ExperienceItem {
  period: string
  current: boolean
  title: string
  company: string
  details: string[]
  tags: string[]
}

export interface EducationItem {
  period: string
  title: string
  org: string
  honors?: boolean
}

export const PROFESSIONAL_EXPERIENCE: ExperienceItem[] = [
  {
    period: 'Mar 2024 — Sep 2026',
    current: false,
    title: 'Platform Engineer',
    company: 'Codincloud',
    details: [
      'Automated Hetzner infrastructure provisioning with Terraform and Ansible, reducing infrastructure build time by 40%.',
      'Increased deployment frequency by 30% through CI workflows in a production environment.',
      'Integrated Vault, Tailscale and Authentik to eliminate plaintext secrets and improved security posture by 50%+.',
      'Built observability with Grafana and ELK, reducing mean time to detect incidents by 25%.',
      'Integrated CrowdSec with Traefik for real-time traffic filtering at the edge.',
      'Managed production workloads and service exposure using Docker Swarm, Traefik and Portainer.',
    ],
    tags: [
      'Terraform',
      'Ansible',
      'Hetzner',
      'Docker Swarm',
      'Traefik',
      'Vault',
      'Tailscale',
      'Authentik',
      'CrowdSec',
      'Grafana',
      'ELK',
      'Portainer',
    ],
  },
  {
    period: 'Jan 2023 — May 2023',
    current: false,
    title: 'Backend Developer Intern',
    company: 'Tunisian Cloud, Tunisia',
    details: [
      'Developed and optimized backend services for a cloud-based SaaS marketplace using Golang (Gin), focusing on performance, scalability, and clean API design.',
      'Containerized backend services with Docker, enabling environment parity across local, staging, and production deployments.',
      'Implemented a GitLab CI/CD pipeline automating build, test, and validation stages, improving code quality and accelerating release cycles.',
    ],
    tags: ['Golang', 'Gin', 'Docker', 'GitLab CI/CD'],
  },
]

export const EDUCATION: EducationItem[] = [
  {
    period: 'Sep 2023 — Jun 2026',
    title: 'National Engineering Diploma in Cloud Engineering',
    org: 'EPI Digital School, Sousse, Tunisia',
  },
  {
    period: 'Sep 2020 — Jun 2023',
    title: "Bachelor's Degree in Computer Science",
    org: 'Faculty of Sciences of Sfax, Sfax, Tunisia',
    honors: true,
  },
]